// extracted by mini-css-extract-plugin
module.exports = {"ContactSection":"ContactSection_ContactSection__mNQyV","Title":"ContactSection_Title__-24Xf","Image":"ContactSection_Image__n85LS","InfoColumn":"ContactSection_InfoColumn__qyJ32"};